(function () {
  'use strict';

  var FILTER_PARAM = 'filter';
  var SORT_PARAM = 'sort_by';

  function readFilterFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get(FILTER_PARAM) || 'all';
  }

  function writeFilterToUrl(handle, opts) {
    var params = new URLSearchParams(window.location.search);
    if (handle === 'all') {
      params.delete(FILTER_PARAM);
    } else {
      params.set(FILTER_PARAM, handle);
    }
    var query = params.toString();
    var newUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    if (opts && opts.replace) {
      window.history.replaceState({ filter: handle }, '', newUrl);
    } else {
      window.history.pushState({ filter: handle }, '', newUrl);
    }
  }

  function getItemBadges(item) {
    var raw = item.getAttribute('data-badges') || '';
    if (!raw) return [];
    return raw.split(/\s+/).filter(Boolean);
  }

  function applyFilter(root, handle, opts) {
    var items = root.querySelectorAll('.collection-grid__item');
    var visibleCount = 0;

    items.forEach(function (item) {
      var matches = handle === 'all' || getItemBadges(item).indexOf(handle) !== -1;
      item.hidden = !matches;
      if (matches) visibleCount++;
    });

    var buttons = root.querySelectorAll('.collection-grid__filter');
    var activeBtn = null;
    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-filter') === handle;
      btn.classList.toggle('is-active', isActive);
      if (isActive) activeBtn = btn;
    });

    // Fallback to "all" if the requested filter doesn't exist in the DOM
    if (!activeBtn && handle !== 'all') {
      applyFilter(root, 'all', opts);
      return;
    }

    var empty = root.querySelector('[data-empty]');
    if (empty) empty.hidden = visibleCount > 0;

    // Reveal the active pill only on user-initiated changes — never on page
    // load, so navigating to a collection always lands at scroll position 0.
    if (activeBtn && opts && opts.reveal) ensureFilterInView(activeBtn);
  }

  function ensureFilterInView(btn) {
    // Scroll the pills strip horizontally only. scrollIntoView is deliberately
    // avoided: it also adjusts the document's vertical scroll, which made
    // collection pages land scrolled down past the header.
    var strip = btn.closest('.collection-grid__filters');
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;

    var stripRect = strip.getBoundingClientRect();
    var btnRect = btn.getBoundingClientRect();
    var delta = 0;
    if (btnRect.left < stripRect.left) {
      delta = btnRect.left - stripRect.left;
    } else if (btnRect.right > stripRect.right) {
      delta = btnRect.right - stripRect.right;
    }
    if (!delta) return;

    try {
      strip.scrollBy({ left: delta, behavior: 'smooth' });
    } catch (_e) {
      strip.scrollLeft += delta;
    }
  }

  function bindFilters(root) {
    root.querySelectorAll('.collection-grid__filter').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-filter');
        if (!handle) return;
        var current = readFilterFromUrl();
        if (handle === current) return;
        writeFilterToUrl(handle);
        applyFilter(root, handle, { reveal: true });
      });
    });
  }

  function bindSort(root) {
    var select = root.querySelector('[data-sort-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set(SORT_PARAM, select.value);
      window.location.search = params.toString();
    });

    // Prevent default GET form submit; we handle navigation in the change handler.
    var form = root.querySelector('[data-sort-form]');
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });
    }
  }

  function bindPopState(root) {
    window.addEventListener('popstate', function () {
      applyFilter(root, readFilterFromUrl(), { reveal: true });
    });
  }

  function init(root) {
    if (root._collectionGridInit) return;
    root._collectionGridInit = true;

    bindFilters(root);
    bindSort(root);
    bindPopState(root);

    var initial = readFilterFromUrl();
    applyFilter(root, initial);
  }

  function boot() {
    document.querySelectorAll('[data-collection-grid]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
